import { render, staticRenderFns } from "./WellnessSummary.vue?vue&type=template&id=70ca8666&scoped=true"
import script from "./WellnessSummary.vue?vue&type=script&lang=js"
export * from "./WellnessSummary.vue?vue&type=script&lang=js"
import style0 from "./WellnessSummary.vue?vue&type=style&index=0&id=70ca8666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ca8666",
  null
  
)

export default component.exports